module.exports = __webpack_public_path__ + "static/media/provider-header-image.3958c6cb.jpg";